import { makeStyles } from '@material-ui/styles';

export const useTreatmentHistoryStyles = makeStyles(() => ({
  button: {
    width: '100%',
    margin: '10px auto',
    fontSize: 18,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    '&.alignLeft': {
      textAlign: 'left',
    },
  },
  alignedButton: {
    textAlign: 'left',
    '.rtl &': {
      textAlign: 'right',
    },
  },
}));

export const useTreatmentIntroStyles = makeStyles(theme => ({
  root: {
    margin: '10px 0',
  },
  label: {
    fontSize: 16,
    lineHeight: '24px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
}));
